import { createFileRoute } from "@tanstack/react-router";
import { SkillsPage } from "@/components/features/skills/SkillsPage";
export const Route = createFileRoute("/_auth/skills")({
  component: SkillsPage,
});
